import {
  ArchiveBoxIcon,
  BanknotesIcon,
  BuildingOffice2Icon,
  ChartBarSquareIcon,
  CircleStackIcon,
  ClipboardDocumentCheckIcon,
  ClipboardDocumentIcon,
  Cog6ToothIcon,
  DocumentDuplicateIcon,
  GiftIcon,
  IdentificationIcon,
  LockClosedIcon,
  MegaphoneIcon,
  NewspaperIcon,
  RectangleStackIcon,
  TrophyIcon,
  UserGroupIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import {
  AutoFacAconfigationsPage,
  AutoFacAconfigationsParticipantsPage,
  BankingTrayOffersPage,
  BankingTrayPage,
  BatchReportingPage,
  BrokerPage,
  BrokersPage,
  CancelledOffersPage,
  ClaimSharePaymentsPage,
  ClaimsKEKPage,
  ClaimsPage,
  ClaimsSharesPaymentKEKPage,
  ClassOFBusinessKEKPage,
  ClassOfBusinessPage,
  CreateClosingKekPage,
  CreateClosingPage,
  CreateSlipKEKPage,
  CreateSlipPage,
  CreditNotesKEKPage,
  CreditNotesPage,
  DashboardKEKPage,
  DashboardPage,
  EmployeesKEKPage,
  EndorsementPage,
  EndorsementsPage,
  EndorsementsPageKEK,
  FinanceReportsPage,
  InsurerKEKPage,
  InsurerPage,
  InsurerPaymentsKEKPage,
  InsurerPaymentsPage,
  InsurersKEKPage,
  InsurersPage,
  ManageTreatyPage,
  NotificationsPage,
  OfferPage,
  PlaceItOffersPage,
  PlaceItPromotionsPage,
  PlaceItRewardsPage,
  ProfilePage,
  ReInsurerKEKPage,
  ReInsurerPage,
  ReInsurerPaymentsPage,
  ReInsurersKEKPage,
  ReInsurersPage,
  ReinstatementOffersPage,
  ReportsPage,
  ResetPasswordPage,
  SettingsPage,
  SignInPage,
  TreatiesPage,
  TreatyClaimsPage,
  TreatyProgramDeductionsPage,
  TreatyProgramsPage,
  TreatyReportsPage,
  TreatySchedulePage,
  UnapprovedClosingsPage,
  UnderwritersPage,
  ViewClaimSharesPage,
  ViewClaimsKEKPage,
  ViewClaimsPage,
  ViewClaimsSharesKEKPage,
  ViewOfferKekPage,
  ViewTreatyPage,
} from "pages";
import { Domain, UserPermission } from "_graphql/cache/auth";
import { Outlet, Route } from "react-location";

import { DocumentPlusIcon } from "@heroicons/react/24/solid";
import LeaderboardPage from "pages/leaderboard";
import PointRedemptionsPage from "pages/points-redemptions";
import ProductionReportsPage from "pages/production-reports";
import TargetBadgesPage from "pages/place-it-rewards-targets";
import TargetRatesPage from "pages/place-it-rewards-target-rates";
import TreatyClaimParticipantsPage from "pages/treaty-claim-participants";
import TreatyClaimPaymentsPage from "pages/treaty-claim-payments";
import { DocumentMinusIcon } from "@heroicons/react/20/solid";

export type RouteProps = Omit<Route, "children"> & {
  id?: string;
  withPermissions?: UserPermission[];
  navigation?: boolean;
  sidebar?: { label: string; icon: any };
  children?: RouteProps[];
  withDomains?: Domain[];
};

const routes: RouteProps[] = [
  {
    id: "dashboard-visal-comfy-root",
    path: "/",
    element: <Outlet />,
    sidebar: {
      label: "Dashboard",
      icon: ChartBarSquareIcon,
    },
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Dashboard",
      section: "General",
    },
    children: [
      {
        id: "dashboard-visal-comfy",
        path: "/",
        element: <DashboardPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    id: "dashboard-kek-root",
    path: "/",
    element: <Outlet />,
    sidebar: {
      label: "Dashboard",
      icon: ChartBarSquareIcon,
    },
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Dashboard",
      section: "General",
    },
    children: [
      {
        id: "dashboard-kek",
        path: "/",
        element: <DashboardKEKPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    id: "leaderboard-root",
    path: "/leaderboard",
    element: <Outlet />,
    sidebar: {
      label: "Target Monitor",
      icon: TrophyIcon,
    },
    meta: {
      layout: "App",
      breadcrumb: () => "Target Monitor",
      section: "General",
    },
    withPermissions: ["analytics:*"],
    withDomains: ["Visal", "Comfy"],
    children: [
      {
        id: "leaderboard-main",
        path: "/",
        element: <LeaderboardPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    id: "create-slip-visal-comfy-root",
    path: "create-slip",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Create Slip",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Create Slip",
      icon: DocumentPlusIcon,
    },
    withPermissions: [
      "*:*",
      "offers:*",
      "offers:view",
      "offers:manage",
      "offers:create",
      "offers:update",
    ],
    withDomains: ["Visal", "Comfy"],
    children: [
      {
        id: "create-slip-visal-comfy",
        path: "/",
        element: <CreateSlipPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        id: "create-slip-visal-comfy-offer-view",
        path: ":offer/view",
        element: <OfferPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => `View Slip`,
        },
      },
    ],
  },
  {
    id: "create-slip-kek-root",
    path: "create-slip",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Create Slip",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Create Slip",
      icon: DocumentPlusIcon,
    },
    withPermissions: [
      "*:*",
      "offers:*",
      "offers:view",
      "offers:manage",
      "offers:create",
      "offers:update",
    ],
    withDomains: ["KEK"],
    children: [
      {
        id: "create-slip-kek",
        path: "/",
        element: <CreateSlipKEKPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        id: "create-slip-kek-offer-view",
        path: ":offer/view",
        element: <ViewOfferKekPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => `View Slip`,
        },
      },
    ],
  },
  {
    id: "unapproved-closings-kek-root",
    path: "unapproved-closings",
    element: <Outlet />,
    withPermissions: ["*:*", "offers:*", "offers:approve"],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Unapproved Closings",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Unapproved Closings",
      icon: DocumentPlusIcon,
    },
    children: [
      {
        id: "unapproved-closings-kek",
        path: "/",
        element: <UnapprovedClosingsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
        children: [],
      },
      {
        id: "unapproved-closings-kek-offer-credit-notes",
        path: ":offer/credit-notes",
        element: <CreditNotesPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Credit Notes",
        },
      },
      {
        id: "unapproved-closings-kek-treaty-view-root",
        path: ":treaty/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Treaty",
        },
        children: [
          {
            id: "unapproved-closings-kek-treaty-view",
            path: "/",
            element: <ViewTreatyPage />,
            meta: {
              layout: "App",
              section: "General",
              // breadcrumb: () => "View Treaty",
            },
          },
          {
            id: "unapproved-closings-kek-treaty-manage-treaty",
            path: ":ref/manage-treaty",
            element: <ManageTreatyPage />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: ({ ref }: any) =>
                `Manage Treaty - ${ref?.replaceAll("__", "/")}`,
            },
          },
        ],
      },
    ],
  },
  {
    id: "create-closing-kek-root",
    path: "create-closing",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "offers:*",
      "offers:view",
      "offers:manage",
      "offers:create",
      "offers:update",
      "offers:reinstate",
      "offers:approve",
      "offers:payment",
    ],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Create Closing",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Create Closing",
      icon: LockClosedIcon,
    },
    children: [
      {
        id: "create-closing-kek",
        path: "/",
        element: <CreateClosingKekPage />,
        meta: {
          layout: "App",
          section: "General",
        },
        children: [],
      },
      {
        id: "create-closing-kek-offer-credit-notes",
        path: ":offer/credit-notes",
        element: <CreditNotesKEKPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Credit Notes",
        },
      },
    ],
  },
  {
    id: "create-closing-visal-comfy-root",
    path: "create-closing",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "offers:*",
      "offers:view",
      "offers:manage",
      "offers:create",
      "offers:update",
      "offers:reinstate",
      "offers:approve",
      "offers:payment",
    ],
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Create Closing",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Create Closing",
      icon: LockClosedIcon,
    },
    children: [
      {
        id: "create-closing-visal-comfy",
        path: "/",
        element: <CreateClosingPage />,
        meta: {
          layout: "App",
          section: "General",
        },
        children: [],
      },
      {
        id: "create-closing-visal-comfy-offer-credit-notes",
        path: ":offer/credit-notes",
        element: <CreditNotesPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Credit Notes",
        },
      },
    ],
  },
  {
    id: "reinstatement-offers-kek-root",
    path: "reinstatement-offers",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "offers:*",
      "offers:view",
      "offers:manage",
      "offers:reinstate",
    ],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Reinstatement Offers",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Reinstatement Offers",
      icon: CircleStackIcon,
    },
    children: [
      {
        id: "reinstatement-offers-kek",
        path: "/",
        element: <ReinstatementOffersPage />,
        meta: {
          layout: "App",
          section: "General",
        },
        children: [],
      },
    ],
  },
  {
    id: "banking-tray-kek-root",
    path: "banking-tray",
    element: <Outlet />,
    withPermissions: ["*:*", "offers:*", "offers:payment"],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Banking Tray",
      section: "Finance",
    },
    sidebar: {
      label: "Banking Tray",
      icon: BanknotesIcon,
    },
    children: [
      {
        id: "banking-tray-kek",
        path: "/",
        element: <BankingTrayPage />,
        meta: {
          layout: "App",
          section: "General",
        },
        children: [],
      },
      {
        id: "banking-tray-kek-view",
        path: ":id/view",
        element: <BankingTrayOffersPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: ({ cheque_number }: any) => `Offers Related`,
        },
        children: [],
      },
    ],
  },
  {
    id: "endorsements-visal-comfy-root",
    path: "endorsements",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "endorsements:*",
      "endorsements:view",
      "endorsements:manage",
      "endorsements:create",
      "endorsements:update",
    ],
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Endorsements",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Endorsements",
      icon: ClipboardDocumentCheckIcon,
    },
    children: [
      {
        id: "endorsements-visal-comfy",
        path: "/",
        element: <EndorsementsPage />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
        },
        children: [],
      },
      {
        id: "endorsements-visal-comfy-endorsement-policy-number",
        path: ":endorsement/endorsement/:endorsement_policy_number",
        element: <EndorsementPage />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
          breadcrumb: ({
            endorsement_policy_number,
          }: {
            endorsement_policy_number: string;
          }) => endorsement_policy_number,
        },
        children: [],
      },
    ],
  },
  {
    id: "endorsements-kek-root",
    path: "endorsements",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "endorsements:*",
      "endorsements:view",
      "endorsements:manage",
      "endorsements:create",
      "endorsements:update",
    ],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Endorsements",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Endorsements",
      icon: ClipboardDocumentCheckIcon,
    },
    children: [
      {
        id: "endorsements-kek",
        path: "/",
        element: <EndorsementsPageKEK />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
        },
        children: [],
      },
      {
        id: "endorsements-kek-endorsement-policy-number",
        path: ":endorsement/endorsement/:endorsement_policy_number",
        element: <EndorsementPage />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
          breadcrumb: ({
            endorsement_policy_number,
          }: {
            endorsement_policy_number: string;
          }) => endorsement_policy_number,
        },
        children: [],
      },
    ],
  },
  {
    id: "insurers-visal-comfy-root",
    path: "insurers",
    withPermissions: [
      "*:*",
      "insurers:*",
      "insurers:manage",
      "insurers:create",
      "insurers:update",
    ],
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Insurers",
      section: "Clients",
    },
    sidebar: {
      label: "Insurers",
      icon: UsersIcon,
    },
    withDomains: ["Visal", "Comfy"],
    children: [
      {
        id: "insurers-visal-comfy",
        path: "/",
        element: <InsurersPage />,
        meta: {
          layout: "App",
          section: "Clients",
        },
        children: [],
      },
      {
        id: "insurers-visal-comfy-insurer-view-root",
        path: ":insurer/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "Clients",
          breadcrumb: () => "View Insurer",
        },
        children: [
          {
            id: "insurers-visal-comfy-insurer-view",
            path: "/",
            element: <InsurerPage />,
            meta: {
              layout: "App",
              section: "Clients",
            },
          },
          {
            id: "insurers-visal-comfy-insurer-payments-root",
            path: ":offer/payments",
            element: <Outlet />,
            meta: {
              layout: "App",
              section: "Clients",
              breadcrumb: () => "View Payments",
            },
            children: [
              {
                id: "insurers-visal-comfy-insurer-payments",
                path: "/",
                element: <InsurerPaymentsPage />,
                meta: {
                  layout: "App",
                  section: "Clients",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "insurers-kek-root",
    path: "insurers",
    withPermissions: [
      "*:*",
      "insurers:*",
      "insurers:manage",
      "insurers:create",
      "insurers:update",
    ],
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Insurers",
      section: "Clients",
    },
    sidebar: {
      label: "Insurers",
      icon: UsersIcon,
    },
    withDomains: ["KEK"],
    children: [
      {
        id: "insurers-kek",
        path: "/",
        element: <InsurersKEKPage />,
        meta: {
          layout: "App",
          section: "Clients",
        },
        children: [],
      },
      {
        id: "insurers-kek-insurer-view-root",
        path: ":insurer/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "Clients",
          breadcrumb: () => "View Insurer",
        },
        children: [
          {
            id: "insurers-kek-insurer-view",
            path: "/",
            element: <InsurerKEKPage />,
            meta: {
              layout: "App",
              section: "Clients",
            },
          },
          {
            id: "insurers-kek-insurer-payments-root",
            path: ":offer/payments",
            element: <Outlet />,
            meta: {
              layout: "App",
              section: "Clients",
              breadcrumb: () => "View Payments",
            },
            children: [
              {
                id: "insurers-kek-insurer-payments",
                path: "/",
                element: <InsurerPaymentsKEKPage />,
                meta: {
                  layout: "App",
                  section: "Clients",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "re-insurers-kek-root",
    path: "re-insurers",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "reinsurers:*",
      "reinsurers:manage",
      "reinsurers:create",
      "reinsurers:update",
    ],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Re-Insurers",
      section: "Clients",
    },
    sidebar: {
      label: "Re-Insurers",
      icon: UserGroupIcon,
    },
    children: [
      {
        id: "re-insurers-kek",
        path: "/",
        element: <ReInsurersKEKPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        id: "re-insurers-kek-reinsurer-root",
        path: ":reInsurer",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Re-Insurer",
        },
        children: [
          {
            id: "re-insurers-kek-reinsurer",
            path: "/",
            element: <ReInsurerKEKPage />,
            meta: {
              layout: "App",
              section: "Clients",
            },
          },
          {
            id: "re-insurers-kek-reinsurer-payments",
            path: ":offer_participant/payments/:offer",
            element: <ReInsurerPaymentsPage />,
            meta: {
              layout: "App",
              section: "Clients",
              breadcrumb: () => "View Re-Insurer Payments",
            },
          },
        ],
      },
    ],
  },
  {
    id: "re-insurers-visal-comfy-root",
    path: "re-insurers",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "reinsurers:*",
      "reinsurers:manage",
      "reinsurers:create",
      "reinsurers:update",
    ],
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Re-Insurers",
      section: "Clients",
    },
    sidebar: {
      label: "Re-Insurers",
      icon: UserGroupIcon,
    },
    children: [
      {
        id: "re-insurers-visal-comfy",
        path: "/",
        element: <ReInsurersPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        id: "re-insurers-visal-comfy-reinsurer-root",
        path: ":reInsurer",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Re-Insurer",
        },
        children: [
          {
            id: "re-insurers-visal-comfy-reinsurer",
            path: "/",
            element: <ReInsurerPage />,
            meta: {
              layout: "App",
              section: "Clients",
            },
          },
          {
            id: "re-insurers-visal-comfy-reinsurer-payments",
            path: ":offer_participant/payments/:offer",
            element: <ReInsurerPaymentsPage />,
            meta: {
              layout: "App",
              section: "Clients",
              breadcrumb: () => "View Re-Insurer Payments",
            },
          },
        ],
      },
    ],
  },
  {
    id: "brokers-root",
    path: "brokers",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Reinsurance Brokers",
      section: "Clients",
    },
    sidebar: {
      label: "Reinsurance Brokers",
      icon: BuildingOffice2Icon,
    },
    children: [
      {
        id: "brokers-main",
        path: "/",
        element: <BrokersPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        id: "brokers-broker-root",
        path: ":broker",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Broker",
        },
        children: [
          {
            id: "brokers-broker",
            path: "/",
            element: <BrokerPage />,
            meta: {
              layout: "App",
              section: "General",
            },
          },
          {
            id: "brokers-broker-treaty-view-root",
            path: ":treaty/view",
            element: <Outlet />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: () => "View Treaty",
            },
            children: [
              {
                id: "brokers-broker-treaty-view",
                path: "/",
                element: <ViewTreatyPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  // breadcrumb: () => "View Treaty",
                },
              },
              {
                id: "brokers-broker-manage-treaty",
                path: ":ref/manage-treaty",
                element: <ManageTreatyPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  breadcrumb: ({ ref }: any) =>
                    `Manage Treaty - ${ref?.replaceAll("__", "/")}`,
                },
              },
            ],
          },
        ],
      },
    ],
    withPermissions: [
      "*:*",
      "reinsurance_brokers:*",
      "reinsurance_brokers:manage",
      "reinsurance_brokers:create",
      "reinsurance_brokers:update",
    ],
  },
  {
    id: "class-of-business-visal-comfy-root",
    path: "class-of-business",
    element: <Outlet />,
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Setup Business",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Setup Business",
      icon: DocumentDuplicateIcon,
    },
    children: [
      {
        id: "class-of-business-visal-comfy",
        path: "/",
        element: <ClassOfBusinessPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
    withPermissions: [
      "*:*",
      "business:*",
      "business:manage",
      "business:create",
      "business:delete",
      "business:update",
    ],
  },
  {
    id: "class-of-business-kek-root",
    path: "class-of-business",
    element: <Outlet />,
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Setup Business",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Setup Business",
      icon: DocumentDuplicateIcon,
    },
    children: [
      {
        id: "class-of-business-kek",
        path: "/",
        element: <ClassOFBusinessKEKPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
    withPermissions: [
      "*:*",
      "business:*",
      "business:manage",
      "business:create",
      "business:delete",
      "business:update",
    ],
  },
  {
    id: "claims-visal-comfy-root",
    path: "claims",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Facultative Claims",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Facultative Claims",
      icon: NewspaperIcon,
    },
    withDomains: ["Visal", "Comfy"],
    children: [
      {
        id: "claims-visal-comfy",
        path: "/",
        element: <ClaimsPage />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
        },
      },
      {
        id: "claims-visal-comfy-all-claims-root",
        path: "/:offer/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Claims",
        },
        children: [
          {
            id: "claims-visal-comfy-all-claims",
            path: "/",
            element: <ViewClaimsPage />,
            meta: {
              layout: "App",
              section: "General",
              // breadcrumb: () => "View Shares",
            },
          },
          {
            id: "claims-visal-comfy-all-claims-claim-root",
            path: ":claim/view",
            element: <Outlet />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: () => "View Shares",
            },
            children: [
              {
                id: "claims-visal-comfy-all-claims-claim",
                path: "/",
                element: <ViewClaimSharesPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  // breadcrumb: () => "View Shares",
                },
              },
              {
                id: "claims-visal-comfy-all-claims-claim-share-payments",
                path: ":share/payments",
                element: <ClaimSharePaymentsPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  breadcrumb: () => "View Share Payments",
                },
              },
            ],
          },
        ],
      },
    ],
    withPermissions: [
      "*:*",
      "claims:*",
      "claims:manage",
      "claims:create",
      "claims:delete",
      "claims:update",
    ],
  },
  {
    id: "claims-kek-root",
    path: "claims",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Facultative Claims",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Facultative Claims",
      icon: NewspaperIcon,
    },
    withDomains: ["KEK"],
    children: [
      {
        id: "claims-kek",
        path: "/",
        element: <ClaimsKEKPage />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
        },
      },
      {
        id: "claims-kek-all-claims-root",
        path: "/:offer/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Claims",
        },
        children: [
          {
            id: "claims-kek-all-claims",
            path: "/",
            element: <ViewClaimsKEKPage />,
            meta: {
              layout: "App",
              section: "General",
              // breadcrumb: () => "View Shares",
            },
          },
          {
            id: "claims-kek-all-claims-claim-root",
            path: ":claim/view",
            element: <Outlet />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: () => "View Shares",
            },
            children: [
              {
                id: "claims-kek-all-claims-claim",
                path: "/",
                element: <ViewClaimsSharesKEKPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  // breadcrumb: () => "View Shares",
                },
              },
              {
                id: "claims-kek-all-claims-claim-share-payments",
                path: ":share/payments",
                element: <ClaimsSharesPaymentKEKPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  breadcrumb: () => "View Share Payments",
                },
              },
            ],
          },
        ],
      },
    ],
    withPermissions: [
      "*:*",
      "claims:*",
      "claims:manage",
      "claims:create",
      "claims:delete",
      "claims:update",
    ],
  },
  {
    id: "employees-root",
    path: "employees",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Employees",
      section: "Others",
    },
    sidebar: {
      label: "Employees",
      icon: IdentificationIcon,
    },
    children: [
      {
        id: "employees-main",
        path: "/",
        element: <EmployeesKEKPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
    withDomains: ["KEK", "Visal", "Comfy"],
  },
  {
    id: "settings-root",
    path: "settings",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "User Roles",
      section: "Others",
    },
    sidebar: {
      label: "User Roles",
      icon: Cog6ToothIcon,
    },
    children: [
      {
        id: "settings-main",
        path: "/",
        element: <SettingsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
    // withDomains: ["KEK"],
    withPermissions: [
      "*:*",
      "employees:*",
      "employees:create",
      "employees:manage",
      "employees:delete",
      "employees:reset",
      "employees:update",
    ],
  },
  {
    id: "auto-fac-configurations-visal-comfy-root",
    path: "auto-fac-configurations",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Auto Fac Configurations",
      section: "Others",
    },
    sidebar: {
      label: "Auto Fac Configurations",
      icon: Cog6ToothIcon,
    },
    withDomains: ["Visal", "Comfy"],
    children: [
      {
        id: "auto-fac-configurations-visal-comfy",
        path: "/",
        element: <AutoFacAconfigationsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        id: "auto-fac-configurations-visal-comfy-participants",
        path: ":id/participants",
        element: <AutoFacAconfigationsParticipantsPage />,
        meta: {
          layout: "App",
          breadcrumb: () => "Participants",
          section: "General",
        },
      },
    ],
    withPermissions: [
      "*:*",
      "auto_fac:*",
      "auto_fac:create",
      "auto_fac:manage",
      "auto_fac:view",
      "auto_fac:update",
      "auto_fac:delete",
    ],
  },
  {
    id: "reports-visal-comfy-root",
    path: "reports",
    element: <Outlet />,
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Reports",
      section: "Reports",
    },
    sidebar: {
      label: "Reports",
      icon: ArchiveBoxIcon,
    },
    withPermissions: [
      "*:*",
      "reports:*",
      "reports:manage",
      "reports:create",
      "reports:update",
    ],
    children: [
      {
        id: "reports-visal-comfy",
        path: "/",
        element: <ReportsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  // {
  //   path: "reports",
  //   element: <Outlet />,
  //   withDomains: ["KEK"],
  //   withPermissions: [],
  //   meta: {
  //     layout: "App",
  //     breadcrumb: () => "Reports",
  //     section: "Reports",
  //   },
  //   sidebar: {
  //     label: "Reports",
  //     icon: ArchiveBoxIcon,
  //   },
  //   children: [
  //     {
  //       id: "all",
  //       path: "/",
  //       element: <ReportsKEKPage />,
  //       meta: {
  //         layout: "App",
  //         section: "General",
  //       },
  //     },
  //   ],
  // },
  {
    id: "finance-reports-kek-root",
    path: "finance-reports",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Finance Reports",
      section: "Finance",
    },
    sidebar: {
      label: "Finance Reports",
      icon: ArchiveBoxIcon,
    },
    withPermissions: [
      "*:*",
      "reports:*",
      "reports:manage",
      "reports:create",
      "reports:update",
    ],
    withDomains: ["KEK"],
    children: [
      {
        id: "finance-reports-kek",
        path: "/",
        element: <FinanceReportsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    id: "production-reports-kek-root",
    path: "production-reports",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Production Reports",
      section: "Reports",
    },
    sidebar: {
      label: "Production Reports",
      icon: ArchiveBoxIcon,
    },
    withPermissions: [
      "*:*",
      "reports:*",
      "reports:manage",
      "reports:create",
      "reports:update",
    ],
    withDomains: ["KEK"],
    children: [
      {
        id: "production-reports-kek",
        path: "/",
        element: <ProductionReportsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    id: "batch-reports-root",
    path: "batch-reports",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Batched Reports",
      section: "Reports",
    },
    sidebar: {
      label: "Batched Reports",
      icon: ArchiveBoxIcon,
    },
    withPermissions: [
      "*:*",
      "reports:*",
      "reports:manage",
      "reports:create",
      "reports:update",
    ],
    children: [
      {
        id: "batch-reports-main",
        path: "/",
        element: <BatchReportingPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    id: "treaty-programs-root",
    path: "treaty-programs",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Setup Treaty program",
      section: "Treaty",
    },
    sidebar: {
      label: "Setup Treaty Program",
      icon: RectangleStackIcon,
    },
    withPermissions: [
      "*:*",
      "treaty_program:*",
      "treaty_program:manage",
      "treaty_program:create",
      "treaty_program:update",
    ],
    children: [
      {
        id: "treaty-programs-main",
        path: "/",
        element: <TreatyProgramsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        id: "treaty-programs-treaty-program-view",
        path: ":treaty_program/view",
        element: <TreatyProgramDeductionsPage />,
        meta: {
          layout: "App",
          breadcrumb: () => "Treaty Program Deductions",
          section: "General",
        },
      },
    ],
  },
  {
    id: "treaties-root",
    path: "treaties",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Treaties",
      section: "Treaty",
    },
    sidebar: {
      label: "Treaties",
      icon: DocumentDuplicateIcon,
    },
    withPermissions: [
      "*:*",
      "treaties:*",
      "treaties:manage",
      "treaties:create",
      "treaties:update",
      "treaties:delete",
    ],
    children: [
      {
        id: "treaties-main",
        path: "/",
        element: <TreatiesPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        id: "treaties-treaty-view-root",
        path: ":treaty/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Treaty",
        },
        children: [
          {
            id: "treaties-treaty-view",
            path: "/",
            element: <ViewTreatyPage />,
            meta: {
              layout: "App",
              section: "General",
              // breadcrumb: () => "View Treaty",
            },
          },
          {
            id: "treaties-treaty-manage-treaty",
            path: ":ref/manage-treaty",
            element: <ManageTreatyPage />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: ({ ref }: any) =>
                `Manage Treaty - ${ref?.replaceAll("__", "/")}`,
            },
          },
        ],
      },
    ],
  },
  {
    id: "treaty-claims-root",
    path: "treaty-claims",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Treaty Claims",
      section: "Treaty",
    },
    sidebar: {
      label: "Treaty Claims",
      icon: CircleStackIcon,
    },
    withPermissions: [
      "*:*",
      "treaty_claims:*",
      "treaty_claims:manage",
      "treaty_claims:create",
      "treaty_claims:update",
      "treaty_claims:delete",
    ],
    children: [
      {
        id: "treaty-claims-main",
        path: "/",
        element: <TreatyClaimsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        id: "treaty-claims-claim-participants-root",
        path: ":claim/participants/:policy",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: ({ policy }: any) =>
            `Treaty Claim - ${policy?.replaceAll("-", "/")}`,
        },
        children: [
          {
            id: "treaty-claims-claim-participants",
            path: "/",
            element: <TreatyClaimParticipantsPage />,
            meta: {
              layout: "App",
              section: "General",
            },
          },
          {
            id: "treaty-claims-claim-share-payments",
            path: ":share/payments",
            element: <TreatyClaimPaymentsPage />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: ({ policy }: any) => `Treaty Claim Share Payments`,
            },
          },
        ],
      },
    ],
  },
  {
    id: "treaty-reports-root",
    path: "treaty-reports",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Treaty Reports",
      section: "Treaty",
    },
    sidebar: {
      label: "Treaty Reports",
      icon: ArchiveBoxIcon,
    },
    withPermissions: [
      "*:*",
      "treaties:*",
      "treaties:manage",
      "treaties:create",
      "treaties:update",
      "treaties:import",
    ],
    children: [
      {
        id: "treaty-reports-main",
        path: "/",
        element: <TreatyReportsPage />,
        meta: {
          layout: "App",
          section: "Treaty",
        },
      },
    ],
  },
  {
    id: "treaty-schedule-root",
    path: "treaty-schedule",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Generate Treaty Payment Schedule",
      section: "Treaty",
    },
    sidebar: {
      label: "Payment Schedules",
      icon: ClipboardDocumentIcon,
    },
    withPermissions: [
      "*:*",
      "treaties:*",
      "treaties:manage",
      "treaties:create",
      "treaties:update",
      "treaties:import",
    ],
    children: [
      {
        id: "treaty-schedule-main",
        path: "/",
        element: <TreatySchedulePage />,
        meta: {
          layout: "App",
          section: "Treaty",
        },
      },
    ],
  },
  {
    id: "underwriters-visal-comfy-root",
    path: "underwriters",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Approve Underwriters",
      section: "Place It",
    },
    sidebar: {
      label: "Approve Underwriters",
      icon: UsersIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:approve_underwriters",
    ],
    children: [
      {
        id: "underwriters-visal-comfy",
        path: "/",
        element: <UnderwritersPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
    ],
  },
  {
    id: "place-it-offers-visal-comfy-root",
    path: "place-it-offers",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Broker Offers",
      section: "Place It",
    },
    sidebar: {
      label: "Broker Offers",
      icon: RectangleStackIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:approve_offers",
    ],
    children: [
      {
        id: "place-it-offers-visal-comfy",
        path: "/",
        element: <PlaceItOffersPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
    ],
  },
  {
    id: "cancelled-offers-visal-comfy-root",
    path: "cancelled-offers",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Cancelled Offers",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Cancelled Offers",
      icon: DocumentMinusIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:approve_underwriters",
    ],
    children: [
      {
        id: "cancelled-offers-visal-comfy",
        path: "/",
        element: <CancelledOffersPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
    ],
  },
  {
    id: "place-it-promotions-visal-comfy-root",
    path: "place-it-promotions",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Campaigns & Promotions",
      section: "Place It",
    },
    sidebar: {
      label: "Campaigns & Promotions",
      icon: MegaphoneIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:manage_campaigns",
    ],
    children: [
      {
        id: "place-it-promotions-visal-comfy",
        path: "/",
        element: <PlaceItPromotionsPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
    ],
  },
  {
    id: "place-it-rewards-visal-comfy-root",
    path: "place-it-rewards",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Targets Configuration",
      section: "Place It",
    },
    sidebar: {
      label: "Targets Configuration",
      icon: GiftIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:manage_targets_configuration",
    ],
    children: [
      {
        id: "place-it-rewards-visal-comfy",
        path: "/",
        element: <PlaceItRewardsPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
      {
        id: "place-it-rewards-visal-comfy-target-badges",
        path: ":id/target-badges",
        element: <TargetBadgesPage />,
        meta: {
          layout: "App",
          section: "Place It",
          breadcrumb: () => "Target Badges",
        },
      },
      {
        id: "place-it-rewards-visal-comfy-target-rates",
        path: ":id/target-rates",
        element: <TargetRatesPage />,
        meta: {
          layout: "App",
          section: "Place It",
          breadcrumb: () => "Target Rates",
        },
      },
    ],
  },
  {
    id: "points-redemptions-visal-comfy-root",
    path: "points-redemptions",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Points Redemptions",
      section: "Place It",
    },
    sidebar: {
      label: "Points Redemptions",
      icon: ClipboardDocumentCheckIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:manage_points_redemptions",
    ],
    children: [
      {
        id: "points-redemptions-visal-comfy",
        path: "/",
        element: <PointRedemptionsPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
    ],
  },
  {
    id: "notifications-root",
    path: "notifications",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "System Notifications",
      section: "Notifcations",
    },
    sidebar: {
      label: "System Notifications",
      icon: RectangleStackIcon,
    },
    children: [
      {
        id: "notifications-main",
        path: "/",
        element: <NotificationsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    id: "profile-root",
    path: "profile",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Profile",
      section: "General",
    },
    children: [
      {
        id: "profile-main",
        path: "/",
        element: <ProfilePage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    id: "cpanel-login",
    path: "cpanel-login",
    element: <SignInPage />,
    meta: {
      layout: "Auth",
      breadcrumb: () => "Auth",
    },
  },
  {
    id: "cpanel-reset-password",
    path: "cpanel-reset-password",
    element: <ResetPasswordPage />,
    meta: {
      layout: "Auth",
      breadcrumb: () => "Auth",
    },
  },
];

export default routes;
